export const API_ADDRESS =
  document.location.origin === "http://localhost:1234"
    ? "http://localhost:3000"
    : document.location.origin;
